export const FILTER_FIELDS_COLUMNS_CLASS =
  'grid-cols-1 @sm:grid-cols-2 @lg:grid-cols-3 @2xl:grid-cols-4 @4xl:grid-cols-5';

export const FILTER_COLUMN_BREAKPOINTS = [
  { minWidthRem: 56, columnCount: 5 },
  { minWidthRem: 42, columnCount: 4 },
  { minWidthRem: 32, columnCount: 3 },
  { minWidthRem: 24, columnCount: 2 },
] as const;
